<template>
  <div>
    <div id="shopify-section-footer" class="shopify-section">
      <footer
        id="footer"
        class="footer-container footer_layout_1"
        style="margin: "
      >
        <div class="footer-center">
          <div class="container">
            <div class="row">
              <div class="col-md-3 col-12">
                <div class="footer-logo" style="margin: 0px 0px 30px 0px">
                  <img
                    class="lazyloaded"
                    src="//cdn.shopify.com/s/files/1/0019/8865/7187/files/logo-transparent-white_2048x.png?v=1644555229"
                    data-src="//cdn.shopify.com/s/files/1/0019/8865/7187/files/logo-transparent-white_2048x.png?v=1644555229"
                    alt=""
                  />
                </div>

                <div class="footer-customhtml">
                  <p>
                    235 East Second Street, <br />
                    Calexico, CA 92231.
                  </p>
                  <p>
                    <img
                      src="https://cdn.shopify.com/s/files/1/0019/8865/7187/files/icn_phone.png?v=1644557658"
                      style="height: 18px"
                    />
                    (760) 357 6846
                  </p>
                </div>
              </div>
              <div class="col-md-3 col-12">
                <h3 class="module-title">Hours</h3>

                <p>
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/8865/7187/files/icn_clock.png?v=1644557658"
                    style="height: 22px"
                  />
                  Monday - Saturday<br />
                  <span style="padding: 25px">10:00 am - 7:00 pm</span>
                </p>
                <p>
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/8865/7187/files/icn_clock.png?v=1644557658"
                    style="height: 22px"
                  />
                  Sunday<br />
                  <span style="padding: 25px">10:00 am - 6:00 pm</span>
                </p>
              </div>
              <div class="col-md-3 col-12">
                <div class="">
                  <div class="footer-link">
                    <h3 class="module-title">Help</h3>

                    <ul class="content">
                      <li><a href="https://www.garlans.com/pages/faqs-1">FAQ's</a></li>

                      <li><a href="https://www.garlans.com/pages/return-policy">Return Policy</a></li>

                      <li>
                        <a href="https://www.garlans.com/pages/shipping-policy">Shipping Policy</a>
                      </li>

                      <li>
                        <a href="https://www.garlans.com/pages/privacy-policy">Privacy Policy</a>
                      </li>

                      <li>
                        <a href="https://www.garlans.com/pages/terms-of-service">Terms of Service</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div id="newsletter" class="col-md-3 col-12">
                <h3 class="module-title">Subscribe and get $5dlls off</h3>

                <!-- Begin Mailchimp Signup Form -->
                <link
                  href="//cdn-images.mailchimp.com/embedcode/classic-10_7.css"
                  rel="stylesheet"
                  type="text/css"
                />
                <div id="mc_embed_signup">
                  <form
                    action="https://garlans.us14.list-manage.com/subscribe/post?u=c035b93e1098fbc6ac9ba20b4&amp;id=4bfcb7b9d9"
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    class="validate"
                    target="_blank"
                    novalidate="novalidate"
                  >
                    <div id="mc_embed_signup_scroll">
                      <div class="indicates-required">
                        <span class="asterisk">*</span> indicates required
                      </div>
                      <div class="mc-field-group">
                        <input
                          type="email"
                          placeholder="Enter Your Email Address*"
                          value=""
                          name="EMAIL"
                          class="required email"
                          id="mce-EMAIL"
                          aria-required="true"
                        />
                      </div>
                      <div hidden="true">
                        <input type="hidden" name="tags" value="684" />
                      </div>
                      <div id="mce-responses" class="clear">
                        <div
                          class="response"
                          id="mce-error-response"
                          style="display: none"
                        ></div>
                        <div
                          class="response"
                          id="mce-success-response"
                          style="display: none"
                        ></div>
                      </div>
                      <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                      <div
                        style="position: absolute; left: -5000px"
                        aria-hidden="true"
                      >
                        <input
                          type="text"
                          name="b_c035b93e1098fbc6ac9ba20b4_4bfcb7b9d9"
                          tabindex="-1"
                          value=""
                        />
                      </div>
                      <div class="clear">
                        <input
                          type="submit"
                          value="Subscribe"
                          name="subscribe"
                          id="mc-embedded-subscribe"
                          class="button"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="col-12 footer-copyrights text-center">
                <div class="footer-copyright" style="padding: 20px">
                  <address>
                    Copyright © 2021 Garlan's. All rights reserved.&nbsp;<a
                      target="_blank?ref=ivdesigngroup"
                      rel="nofollow?ref=ivdesigngroup"
                      href="https://www.shopify.com?utm_campaign=poweredby&amp;utm_medium=shopify&amp;utm_source=onlinestore?ref=ivdesigngroup"
                      >Powered by Shopify</a
                    >.
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div id="back-top" style="">
        <a class="" href="#top"><i class="cs-font clever-icon-up"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
    

<style scoped>
img {
  max-width: 100%;
  height: auto;
  border: 0;
  -ms-interpolation-mode: bicubic;
  -webkit-transition: all 0.4s ease-in-out 0s;
  -moz-transition: all 0.4s ease-in-out 0s;
  -ms-transition: all 0.4s ease-in-out 0s;
  -o-transition: all 0.4s ease-in-out 0s;
  transition: all 0.4s ease-in-out 0s;
}
#mc_embed_signup {
  background: #fff;
  clear: left;
  font: 14px Helvetica, Arial, sans-serif;
  width: 600px;
}
/* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
                   We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */

/* MAIL CHIMP FORM INPUTS ---------------------------------------------------------- */
#mce-EMAIL {
  border: 1px solid #000;
  color: #000;
  height: 11px;
  margin: 0 !important;
  padding: 8px !important;
  width: 217px;
}
#email-subscibe {
  overflow: hidden;
  padding: 30px 0;
}
#mc_embed_signup {
  clear: left;
  overflow: hidden;
}
#mc_embed_signup form {
  display: inline !important;
  padding: 0 !important;
  text-align: center !important;
}
/* Footer Center */
.footer-container {
  color: #666666; }
  .footer-container h3.module-title {
    color: black; }
  .footer-container a {
    color: #666666; }
    .footer-container a:hover {
      color: #bc3c52; }

.popupnewsletter #mc_embed_signup input.input-group-field {
  display: inline-block;
  height: 36px;
  border: 1px solid #000;
  font-size: 14px;
  line-height: 51px;
  color: #000000;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  text-align: left;
  font-weight: 400;
  padding: 0 10px;
  width: 100%;
  background: #fff;
}

#footer #mc_embed_signup {
  clear: left;
  overflow: hidden;
  width: 100% !important;
  background: transparent !important;
  color: #fff;
  text-align: left !important;
}
#footer #mc_embed_signup .mc-field-group {
  width: 100% !important;
}

#footer #mc_embed_signup .mc-field-group input {
  line-height: 50px;
  outline: none;
  padding: 0 10px;
  width: 100%;
  height: 50px;
  border-radius: 0;
  font-size: 14px;
  background: transparent;
  color: #fff;
  border: 1px solid #fff;
  font-family: "Poppins";
}

#footer #mc_embed_signup .mc-field-group input::placeholder {
  color: #fff;
}

#footer #mc_embed_signup .button {
  clear: both;
  border-radius: 0;
  transition: all 0.23s ease-in-out 0s;
  cursor: pointer;
  display: inline-block;
  line-height: 32px;
  margin: 0 5px 10px 0;
  padding: 0 22px;
  text-decoration: none;
  vertical-align: top;
  white-space: nowrap;
  font-family: "Poppins";
  color: #000 !important;
  background: #fff !important;
  text-transform: capitalize !important;
  text-align: left !important;
  height: 50px;
  line-height: 50px;
  border: 0;
  padding: 0 15px;
  font-size: 16px;
  letter-spacing: 0;
  font-weight: 600;
  width: 100%;
}

.footer-container .footer-center {
  background-color: #f4f4f4;
  padding-top: 60px;
  position: relative;
  z-index: 1;
  line-height: 24px;
}
.footer-container
  .footer-center
  .footer-newsletter
  .newsletter
  .input-group-field {
  line-height: 50px;
  color: #fff !important;
  outline: none;
  padding: 0px 10px;
  width: 100%;
  height: 50px;
  border-radius: 0px;
  border: 1px solid #fff !important;
  font-size: 14px;
  background: transparent !important;
}

.footer-container
  .footer-center
  .footer-newsletter
  .newsletter
  .input-group-btn
  > .btn {
  color: #000 !important;
  background: #fff !important;
  text-transform: capitalize !important;
  text-align: left !important;
}

.footer-container
  .footer-center
  .footer-newsletter
  .newsletter
  .input-group-field::placeholder {
  color: #fff !important;
}

.footer-container,
.footer-container .footer-center {
  background: #000 !important;
}
.footer-container .footer-center p,
.footer-container .footer-center a,
.footer-container .footer-center h3{
  color: #fff !important;
  font-size: 14px;
  font-family: Poppins, sans-serif;
}
address {
  font-size: 14px;
  font-family: Poppins, sans-serif;
}

.footer-container .footer-center h3 {
  font-weight: 600px !important;
  font-family: Poppins, sans-serif;
}

.footer-container .footer-center .footer-link ul li a {
    font-size: 14px;
    line-height: 20px;
    text-transform: capitalize;
    text-decoration: none;
}

.footer-container .footer-center h3.module-title {
    letter-spacing: .25px;
    font-size: 16px;
    margin: 0;
    padding-bottom: 22px;
    position: relative;
    text-transform: uppercase;
    line-height: 24px;
    font-weight: 700;
}
ul, ol {
    padding: 0;
    list-style: none;
    margin-bottom: 20px;
}
@media only screen and (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }
}
@media only screen and (min-width: 769px) {
  .mobile-only {
    display: none !important;
  }
}
.footer-container.footer_layout_1 .footer-center .footer-logo {
  max-width: 200px;
}
table td,
table th {
  border-bottom: 0px;
}

@media (min-width: 1200px) {
  .container-menu {
    max-width: 1320px !important;
  }
}

/* http://timpietrusky.com/advanced-checkbox-hack */

@-webkit-keyframes androidbugfix {
  from {
    padding: 0;
  }
  to {
    padding: 0;
  }
}

@media (min-width: 1400px){
  .container {
      max-width: 1140px !important;
  }
}
</style>